import * as React from "react"
import { SVGProps } from "react"
const MedicalKit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.052 1.25H11.948C11.0495 1.24997 10.3003 1.24995 9.70552 1.32991C9.07773 1.41432 8.51093 1.59999 8.05546 2.05546C7.59999 2.51093 7.41432 3.07773 7.32991 3.70552C7.24995 4.3003 7.24997 5.0495 7.25 5.94797L7.25 6.02572C7.70703 6.01076 8.20535 6.00451 8.75 6.00189V6C8.75 5.03599 8.7516 4.38843 8.81654 3.9054C8.87858 3.44393 8.9858 3.24644 9.11612 3.11612C9.24644 2.9858 9.44393 2.87858 9.9054 2.81654C10.3884 2.7516 11.036 2.75 12 2.75C12.964 2.75 13.6116 2.7516 14.0946 2.81654C14.5561 2.87858 14.7536 2.9858 14.8839 3.11612C15.0142 3.24644 15.1214 3.44393 15.1835 3.9054C15.2484 4.38843 15.25 5.03599 15.25 6V6.00189C15.7947 6.00451 16.293 6.01076 16.75 6.02572V5.94801C16.75 5.04954 16.7501 4.3003 16.6701 3.70552C16.5857 3.07773 16.4 2.51093 15.9445 2.05546C15.4891 1.59999 14.9223 1.41432 14.2945 1.32991C13.6997 1.24995 12.9505 1.24997 12.052 1.25Z"
      fill="#2E57FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14C2 10.2288 2 8.34315 3.17157 7.17157C4.34315 6 6.22876 6 10 6H14C17.7712 6 19.6569 6 20.8284 7.17157C22 8.34315 22 10.2288 22 14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H9.99998C6.22876 22 4.34314 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14ZM12.75 12.5C12.75 12.0858 12.4142 11.75 12 11.75C11.5858 11.75 11.25 12.0858 11.25 12.5V13.25H10.5C10.0858 13.25 9.75 13.5858 9.75 14C9.75 14.4142 10.0858 14.75 10.5 14.75H11.25V15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5V14.75H13.5C13.9142 14.75 14.25 14.4142 14.25 14C14.25 13.5858 13.9142 13.25 13.5 13.25H12.75V12.5Z"
      fill="#3699FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18C14.2091 18 16 16.2091 16 14C16 11.7909 14.2091 10 12 10C9.79086 10 8 11.7909 8 14C8 16.2091 9.79086 18 12 18ZM12.75 12.5C12.75 12.0858 12.4142 11.75 12 11.75C11.5858 11.75 11.25 12.0858 11.25 12.5V13.25H10.5C10.0858 13.25 9.75 13.5858 9.75 14C9.75 14.4142 10.0858 14.75 10.5 14.75H11.25V15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5V14.75H13.5C13.9142 14.75 14.25 14.4142 14.25 14C14.25 13.5858 13.9142 13.25 13.5 13.25H12.75V12.5Z"
      fill="#2E57FF"
    />
  </svg>
)
export default MedicalKit
